import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=1257fc1a&"
import script from "./Search.vue?vue&type=script&lang=ts&"
export * from "./Search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports